import moment from "moment-timezone"

export const getStartOfDate = date => {
  return moment(date).startOf("date").toISOString()
}
